import {LabeledTextField} from "../Fields/LabeledTextField.jsx";
import {LuTrash2} from "react-icons/lu";
import React from "react";
import "./NotContainsFilterCondition.css";
import DefaultDropButton from "../Buttons/DefaultDropButton/DefaultDropButton.jsx";

function LessThanCondition({index, options, field, value, onFieldChange, onValueChange, onDelete}: {
    index: number;
    options: string[];
    field: string;
    value: string;
    onFieldChange: (index: number, newValue: string) => void;
    onValueChange: (index: number, newValue: string) => void;
    onDelete: (index: number) => void;
}) {
    return <div className="condition" key={index}>
        <DefaultDropButton
            name={"condition_"+index}
            options={options}
            placeholder="choose field"
            selected={field}
            onSelect={(newValue) => {
                onFieldChange(index, newValue)
            }}
            className="condition-field"
            label={"Field"}
            hideLabel
        />
        <div className="condition-operator"> less than </div>
        <LabeledTextField
            type="text"
            placeholder="(Value)"
            name={"value_"+index}
            value={value}
            onChange={(newValue) => {
                onValueChange(index, newValue)
            }}
            className="condition-value"
            hiddenLabel={"Value"}
        />
        <LuTrash2
            className="trash"
            onClick={() => onDelete(index)}
        />
    </div>
}

export default LessThanCondition;